import React from 'react';

export default function NewspaperPanel({ ctx }) {
  const {
    newspaperAddressSaving,
    newspaperAddressForm,
    setNewspaperAddressForm,
    newspaperStates,
    newspaperMunicipalities,
    newspaperFederalDistricts,
    newspaperPostalCodes,
    newspaperColonias,
    newspaperCities,
    newspaperCatalogLoading,
    newspaperMunicipalitiesLoading,
    handleNewspaperStateChange,
    handleNewspaperMunicipalityChange,
    handleNewspaperPostalCodeChange,
    createNewspaperAddress
  } = ctx;

  return (
    <div className="newspaper-page">
      <section className="newspaper-panel">
        <h2>Domicilio para recibir periodico Regeneracion</h2>
        <p className="newspaper-muted">
          Registra tu domicilio para futuras solicitudes de periodico.
        </p>

        <form className="newspaper-form" onSubmit={createNewspaperAddress}>
          <div className="form-row4">
            <label className="form-field">
              <span className="field-label">Entidad</span>
              <select
                value={newspaperAddressForm.stateId || ''}
                onChange={(e) => handleNewspaperStateChange(e.target.value)}
                disabled={newspaperCatalogLoading}
                required
              >
                <option value="">
                  {newspaperCatalogLoading ? 'Cargando estados...' : 'Selecciona una entidad'}
                </option>
                {newspaperStates.map((state) => (
                  <option key={state.id} value={String(state.id)}>{state.name}</option>
                ))}
              </select>
            </label>
            <label className="form-field">
              <span className="field-label">Distrito</span>
              <select
                value={newspaperAddressForm.federalDistrict}
                onChange={(e) =>
                  setNewspaperAddressForm((prev) => ({ ...prev, federalDistrict: e.target.value }))
                }
                disabled={!newspaperAddressForm.stateId}
              >
                <option value="">{newspaperAddressForm.stateId ? 'Selecciona un distrito' : 'Primero selecciona una entidad'}</option>
                {newspaperFederalDistricts.map((district) => (
                  <option key={district.id} value={String(district.id)}>{district.name}</option>
                ))}
              </select>
            </label>
            <label className="form-field">
              <span className="field-label">Nombre de contacto</span>
              <input
                value={newspaperAddressForm.contactName}
                onChange={(e) =>
                  setNewspaperAddressForm((prev) => ({ ...prev, contactName: e.target.value }))
                }
                required
              />
            </label>
            <label className="form-field">
              <span className="field-label">CP</span>
              <input
                value={newspaperAddressForm.postalCode}
                maxLength={5}
                inputMode="numeric"
                list="newspaper-postal-codes"
                onChange={(e) => handleNewspaperPostalCodeChange(e.target.value)}
                required
              />
              <datalist id="newspaper-postal-codes">
                {newspaperPostalCodes.map((postalCode) => (
                  <option key={postalCode} value={postalCode} />
                ))}
              </datalist>
            </label>
          </div>

          <div className="form-row4">
            <label className="form-field">
              <span className="field-label">Telefono 1</span>
              <input
                value={newspaperAddressForm.phone1}
                inputMode="numeric"
                maxLength={10}
                minLength={10}
                onChange={(e) =>
                  setNewspaperAddressForm((prev) => ({
                    ...prev,
                    phone1: e.target.value.replace(/\D/g, '').slice(0, 10)
                  }))
                }
                required
              />
            </label>
            <label className="form-field">
              <span className="field-label">Telefono 2</span>
              <input
                value={newspaperAddressForm.phone2}
                inputMode="numeric"
                maxLength={10}
                minLength={newspaperAddressForm.phone2 ? 10 : undefined}
                onChange={(e) =>
                  setNewspaperAddressForm((prev) => ({
                    ...prev,
                    phone2: e.target.value.replace(/\D/g, '').slice(0, 10)
                  }))
                }
              />
            </label>
            <label className="form-field">
              <span className="field-label">Municipio</span>
              <select
                value={newspaperAddressForm.municipalityId || ''}
                onChange={(e) => handleNewspaperMunicipalityChange(e.target.value)}
                disabled={!newspaperAddressForm.stateId || newspaperMunicipalitiesLoading}
                required
              >
                <option value="">
                  {newspaperAddressForm.stateId
                    ? (newspaperMunicipalitiesLoading ? 'Cargando municipios...' : 'Selecciona un municipio')
                    : 'Primero selecciona una entidad'}
                </option>
                {newspaperMunicipalities.map((municipality) => (
                  <option key={municipality.id} value={String(municipality.id)}>{municipality.name}</option>
                ))}
              </select>
            </label>
            <label className="form-field">
              <span className="field-label">Colonia</span>
              <input
                value={newspaperAddressForm.colonia}
                list="newspaper-colonias"
                onChange={(e) => setNewspaperAddressForm((prev) => ({ ...prev, colonia: e.target.value }))}
                required
              />
              <datalist id="newspaper-colonias">
                {newspaperColonias.map((colonia) => (
                  <option key={colonia} value={colonia} />
                ))}
              </datalist>
            </label>
          </div>

          <div className="form-row4">
            <label className="form-field">
              <span className="field-label">Calle</span>
              <input
                value={newspaperAddressForm.street}
                onChange={(e) => setNewspaperAddressForm((prev) => ({ ...prev, street: e.target.value }))}
                required
              />
            </label>
            <label className="form-field">
              <span className="field-label">Numero ext</span>
              <input
                value={newspaperAddressForm.numberExt}
                onChange={(e) =>
                  setNewspaperAddressForm((prev) => ({ ...prev, numberExt: e.target.value }))
                }
                required
              />
            </label>
            <label className="form-field">
              <span className="field-label">Numero int</span>
              <input
                value={newspaperAddressForm.numberInt}
                onChange={(e) =>
                  setNewspaperAddressForm((prev) => ({ ...prev, numberInt: e.target.value }))
                }
              />
            </label>
            <label className="form-field">
              <span className="field-label">Ciudad</span>
              <input
                value={newspaperAddressForm.city}
                list="newspaper-cities"
                onChange={(e) => setNewspaperAddressForm((prev) => ({ ...prev, city: e.target.value }))}
              />
              <datalist id="newspaper-cities">
                {newspaperCities.map((city) => (
                  <option key={city} value={city} />
                ))}
              </datalist>
            </label>
          </div>

          <div className="form-row3">
            <label className="form-field">
              <span className="field-label">Entrecalle 1</span>
              <input
                value={newspaperAddressForm.betweenStreet1}
                onChange={(e) =>
                  setNewspaperAddressForm((prev) => ({ ...prev, betweenStreet1: e.target.value }))
                }
              />
            </label>
            <label className="form-field">
              <span className="field-label">Entrecalle 2</span>
              <input
                value={newspaperAddressForm.betweenStreet2}
                onChange={(e) =>
                  setNewspaperAddressForm((prev) => ({ ...prev, betweenStreet2: e.target.value }))
                }
              />
            </label>
            <label className="form-field">
              <span className="field-label">Referencia</span>
              <input
                value={newspaperAddressForm.reference}
                onChange={(e) => setNewspaperAddressForm((prev) => ({ ...prev, reference: e.target.value }))}
              />
            </label>
          </div>

          <label className="form-field" style={{ gridColumn: '1 / -1' }}>
            <span className="field-label">Indicaciones de entrega</span>
            <textarea
              rows={2}
              value={newspaperAddressForm.deliveryInstructions}
              onChange={(e) =>
                setNewspaperAddressForm((prev) => ({ ...prev, deliveryInstructions: e.target.value }))
              }
            />
          </label>

          <div className="newspaper-actions">
            <button type="submit" className="btn-primary" disabled={newspaperAddressSaving}>
              {newspaperAddressSaving ? 'Guardando...' : 'Guardar domicilio'}
            </button>
          </div>
        </form>
      </section>
    </div>
  );
}
